import { type FC, Fragment } from 'react';
import styles from '../styles/attention-notice.module.scss';
import GreyBorderedBox from './grey-bordered-box';

const AttentionNotice: FC<{
    className?: string;
    messages?: string[];
    note?: string;
}> = ({ className, messages, note }) => {
    return (
        <GreyBorderedBox className={className}>
            {(messages ?? []).map((message, index) => (
                <Fragment key={index}>
                    {index > 0 && <br />}
                    {message}
                </Fragment>
            ))}
            {note && <span className={styles.redNotice}>{note}</span>}
        </GreyBorderedBox>
    );
};

export default AttentionNotice;
